import { Box } from "@mui/material";
import i18next from "i18next";
import React from "react";
import styles from "./button.module.scss";
import PropTypes from "prop-types";

const Button = (props) => {
  const {
    buttonType,
    attriType = "button",
    withIcon,
    title,
    iconStyle = "",
    handleClick = () => {},
    showCountSection = false,
    classList = null,
    count = null,
    isDisabled = false,
  } = props;

  return (
    <button
      type={attriType}
      className={`muibtn ${buttonType} ${classList}  ${
        isDisabled ? "muibtn-primary-disabled" : ""
      }`}
      onClick={() => handleClick()}
      data-testid="buttons"
      disabled={isDisabled}
    >
      {withIcon ? <span className={`${iconStyle} butnIcon`}></span> : null}
      <Box className="btnText">{i18next.t(title)}</Box>
      {showCountSection ? (
        <Box className={styles.countSection}>{count}</Box>
      ) : null}
    </button>
  );
};

export default Button;

Button.propTypes = {
  buttonType: PropTypes.any,
  attriType: PropTypes.any,
  withIcon: PropTypes.any,
  title: PropTypes.any,
  iconStyle: PropTypes.any,
  handleClick: PropTypes.any,
  showCountSection: PropTypes.any,
  classList: PropTypes.any,
  count: PropTypes.any,
  isDisabled: PropTypes.any,
};
